const en = {
    required: "Required"
}
export default en;